import {baseUrl} from '@packages/client';
import Head from 'next/head';
import {TITLE_SUFFIX} from '../../../../config/constants';
import {isReleasedRedesignTop} from '../../../../config/unReleasePage';
import {LoggedInTopRecommend} from './LoggedInTopRecommend';

type Props = {
  isStudentVerificationRequired?: boolean;
};

export const LoggedInTopRecommendPage: React.FC<Props> = ({
  isStudentVerificationRequired = false,
}) => {
  const pageTitle = 'おすすめ';
  const canonicalUrl = baseUrl();

  return (
    <>
      <Head>
        <title key="title">{`${isReleasedRedesignTop() ? pageTitle : 'マイページ'}${TITLE_SUFFIX}`}</title>
        <meta
          key="og:title"
          property="og:title"
          content={isReleasedRedesignTop() ? pageTitle : 'マイページ'}
        />
        <meta key="og:url" property="og:url" content={canonicalUrl} />
        <meta
          name="description"
          content="外資・日系トップ企業を目指す学生に役立つ就職活動サイト「外資就活ドットコム」。インターン募集、セミナー、説明会、選考会など、外資・日系トップ企業の新卒採用に関する最新情報を随時掲載。"
        />
        <meta
          name="keywords"
          content="外資・日系トップ企業,企業一覧,外資,就活,インターンシップ,新卒採用,会社説明会,就活コラム,ES・体験記,注目企業"
        />
        <link rel="canonical" href={canonicalUrl} key="canonical" />
      </Head>

      <div className="w-full pc:w-[1200px]">
        <LoggedInTopRecommend
          isStudentVerificationRequired={isStudentVerificationRequired}
        />
      </div>
    </>
  );
};
